import * as moment from "moment";

export class SampleFilters {
    DateDebut: Date = moment(new Date()).subtract(1, 'months').toDate();
    DateFin: Date = new Date();
    ReferenceEOL: string = '';
    ReferenceClient: string = '';
    CodeDossier: string = '';
    Projet: string = '';
    MainContactName: string = ''
}